
import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
//@ts-ignore
import VDataTable from 'vuetify/src/components/VDataTable/VDataTable.js';
//@ts-ignore
import VCheckbox from 'vuetify/src/components/VCheckbox'


@Component({
    extends: VDataTable
})
export default class DataTable extends Vue {

    @Prop(Boolean) loading!: boolean;
    @Prop(Boolean) selectable!: boolean;
    @Prop(Boolean) selectOnRowClick!: boolean;
    @Prop(Boolean) selectOne!: boolean;
    @Prop(Boolean) expand!: boolean;
    @Prop(Array) metrics!: any[];
    @Prop(Array) selectedMetrics!: any[];
    @Prop(Array) headers!: any[];
    @Prop(Object) footer!: object;
    @Prop(Array) items!: any[];
    @Prop(String) grouping!: string;
    @Prop(Array) actions!: any[];
    @Prop(Object) formatters!: object;
    @Prop(Array) headerActions!: any[];

    rerender: number = 0;



    order(obj: any): any[] {
        let result: any[] = [];
        this.processedHeaders.map((e: any) => e.value).forEach((k: any) => {
            if (obj[k] !== undefined) result.push( this.formatCellValue(k, obj[k], obj) );
        });
        return result;
    }

    formatCellValue(value: string, data: any, obj: object){
        //@ts-ignore
        if (this.formatters && this.formatters[value])
        {
            //@ts-ignore
            const formatter = this.formatters[value];
            //@ts-ignore
            return formatter(this.$createElement, data, this, obj);
        }
        else
        {
            //@ts-ignore
            return data
        }
    }

    genFilteredItems () {

        const vtag = this.$createElement;

        const rows = [];
        //@ts-ignore
        for (let index = 0, len = this.filteredItems.length; index < len; ++index) {
            //@ts-ignore
            const item = this.filteredItems[index];
            //@ts-ignore
            const props = this.createProps(item, index);


            //render checkbox
            const select = vtag('td', {
                    style:{
                        padding:'0px 6px',
                        textAlign: 'center'
                    }
                },[
                    vtag('v-checkbox',{
                        props:{
                            inputValue: props.selected,
                            primary: true,
                            hideDetails: true
                        },
                        on:{
                            click:()=>{
                                //@ts-ignore
                                if(this.selectOne){
                                    //@ts-ignore
                                    this.value = this.value.filter((e : any)=> e === props.item);
                                }
                                props.selected = !props.selected;

                            }
                        }
                    })
                ]
            );

            let data = this.order(props.item).map((v: any)=>{
                return vtag('td', [v])
            });

            //@ts-ignore
            if (this.selectable || this.hasSelectAll)
                data.unshift(select);


            //Row level actions
            if (this.actions && this.actions.length){

                let actions = vtag('td', {
                    class: {
                        'data-table__actions': true
                    },
                    style: { textAlign: 'right', padding:'0px' },
                    props: {
                        on:{
                            click:function(ev: any){
                                ev.stopPropagation();
                            }
                        }
                    }
                }, this.actions.map( (C: any) => {
                    return vtag(C, {
                        props:{
                            data: props
                        }
                    }, [])
                }));



                data.push(actions);

            }

            const row = vtag('tr', {
                    props:{
                        active: props.selected,
                    },
                    on: {
                        click: ()=>{
                            if (this.expand) {
                                props.expanded = !props.expanded;
                            }

                            if (!this.selectOnRowClick)
                                return;
                            //@ts-ignore
                            if (this.selectable && !this.hasSelectAll)
                            //@ts-ignore
                                this.value = [];
                            props.selected = !props.selected;



                        }
                    }
                },
                data);

            // console.log(row)
            //@ts-ignore
            rows.push(this.hasTag(row, 'td')
                //@ts-ignore
                ? this.genTR(row, {
                    //@ts-ignore
                    key: this.itemKey ? props.item[this.itemKey] : index,
                    //@ts-ignore
                    attrs: { active: this.isSelected(item) }
                })
                : row);

            if (this.$scopedSlots.expand) {
                //@ts-ignore
                const expandRow = this.genExpandedRow(props);
                rows.push(expandRow)
            }
        }

        return rows
    }


    get processedHeaders(){

        let result: any[] = [];

        if (this.metrics && this.metrics.length && this.selectedMetrics.length)
        {
            let order = this.metrics.map((e:any) => e.value);
            let seq: any[] = [];

            order.forEach((k : any)=>{
                let metric = this.selectedMetrics.filter((m : any)=>m.value === k)[0];
                if(metric) seq.push(metric.value);
            });

            seq.forEach((k: any)=>{
                let metric = this.metrics.filter((m: any)=> {
                    return m.value === k
                })[0];
                result.push(metric);
            });

        }


        if (this.grouping) // move grouping column to first position
        {
            let tail = result.filter((e: any)=> e.value !== this.grouping);
            let head =  result.filter((e : any)=> e.value === this.grouping);
            if (!head.length && this.metrics.length){
                head = this.metrics.filter((e : any)=> e.value === this.grouping);
            }
            return head.concat(tail);
        }
        else
        {
            return result;
        }


        //@ts-ignore
        return this.headers; //for any case
    }

    get headerColumns () {
        //@ts-ignore
        return this.processedHeaders.length + (this.selectable && 1 || 0) + (this.hasSelectAll && 1 || 0) + (this.actions && this.actions.length || 0) ;
    }

    genHeaderSortingData (header: any, children: any, data: any, classes: any) {
        if (!('value' in header)) {
            console.warn('Headers must have a value property that corresponds to a value in the v-model array', this)
        }

        const vtag = this.$createElement;

        data.attrs.tabIndex = 0;
        data.on = {
            click: () => {
                //@ts-ignore
                this.expanded = {};
                //@ts-ignore;
                this.sort(header.value)
            },
            keydown: (e: any) => {
                // check for space
                if (e.keyCode === 32) {
                    e.preventDefault();
                    //@ts-ignore
                    this.sort(header.value)
                }
            }
        };

        classes.push('sortable');
        //@ts-ignore
        const icon = vtag('v-icon', {
            props: {
                small: true
            }
            //@ts-ignore
        }, this.sortIcon);

        if (!header.align || header.align === 'left') {
            children.push(icon)
        } else {
            children.unshift(icon)
        }

        if (this.headerActions && this.headerActions.length){
            const actions = vtag('span', {
                class: {
                    'data-table__header_actions': true
                },
                props: {
                    on:{
                        click:function(ev: any){
                            ev.stopPropagation();
                        }
                    }
                }
                //@ts-ignore
            }, this.headerActions.map( (C: any) => {
                return vtag(C, {
                    props:{
                        data: { header:header, ctx: this}
                    }
                }, [])
            }));


            children.push(actions);
        }

        //@ts-ignore
        const pagination = this.computedPagination;

        //@ts-ignore
        const beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
            classes.push('active');
            if (pagination.descending) {
                classes.push('desc');
                data.attrs['aria-sort'] = 'descending';
                data.attrs['aria-label'] += ': Sorted descending. Activate to remove sorting.' // TODO: Localization
            } else {
                classes.push('asc');
                data.attrs['aria-sort'] = 'ascending';
                data.attrs['aria-label'] += ': Sorted ascending. Activate to sort descending.' // TODO: Localization
            }
        } else {
            data.attrs['aria-label'] += ': Not sorted. Activate to sort ascending.' // TODO: Localization
        }
    }

    genHeader (header: any, key: any) {
        const array = [
            this.$scopedSlots.headerCell
                ? this.$scopedSlots.headerCell({ header })
                //@ts-ignore
                : header[this.headerText]
        ];
        //@ts-ignore
        return this.$createElement('th', ...this.genHeaderData(header, array, key))
    }

    genTBody () {
        //@ts-ignore
        const children = this.genItems();
        return this.$createElement('tbody', children)
    }

    genEmptyItems (content : any) {
        //@ts-ignore
        if (this.hasTag(content, 'tr')) {
            return content
            //@ts-ignore
        } else if (this.hasTag(content, 'td')) {
            //@ts-ignore
            return this.genTR(content)
        } else {
            //@ts-ignore
            return this.genTR([this.$createElement('td', {
                class: {
                    'no-data': true,
                    'text-xs-center': typeof content === 'string'
                },
                attrs: { colspan: this.headerColumns }
            }, content)])
        }
    }

    genTHead () {

        const vtag = this.$createElement;


        const style = document.getElementById('computed');
        //@ts-ignore;
        for (var i=0; i<style.sheet.cssRules.length; i++)
            //@ts-ignore;
            style.sheet.removeRule(i);

        this.processedHeaders.map((o: any, i:number)=>{
            try {
                //@ts-ignore
                style.sheet.addRule(`td:nth-of-type(${i+2}):before`, `content: "${o.text}";`);
            } catch(e) {

            }
        });

        //@ts-ignore
        if (this.hideHeaders) return; // Exit Early since no headers are needed.

        let children = [];

        if (this.$scopedSlots.headers) {
            const row = this.$scopedSlots.headers({
                headers: this.processedHeaders,
                //@ts-ignore
                indeterminate: this.indeterminate,
                //@ts-ignore
                all: this.everyItem
            });
            //@ts-ignore
            children = [this.hasTag(row, 'th') ? this.genTR(row) : row, this.genTProgress()]
        } else {
            //@ts-ignore
            const row = this.processedHeaders.map((o, i) => this.genHeader(o, this.headerKey ? o[this.headerKey] : i));

            const checkbox = vtag(VCheckbox, {
                props: {
                    //@ts-ignore
                    dark: this.dark,
                    //@ts-ignore
                    light: this.light,
                    //@ts-ignore
                    color: this.selectAll === true ? '' : this.selectAll,
                    //@ts-ignore
                    hideDetails: true,
                    //@ts-ignore
                    inputValue: this.everyItem,
                    //@ts-ignore
                    indeterminate: this.indeterminate
                },
                //@ts-ignore
                on: { change: this.toggle }
            });

            //@ts-ignore
            this.hasSelectAll && row.unshift(vtag('th', {attrs:{style:'width:26px'}},[checkbox]));

            //@ts-ignore
            if( this.selectable && !this.hasSelectAll)
                row.unshift(vtag('th',{ style: { textAlign: 'left', width:'26px' } },[vtag('v-icon',['more_vert'])]));

            if( this.actions && this.actions.length)
                row.push(vtag('th',{ style: { textAlign: 'right' } },[vtag('v-icon',['drag_handle'])]));

            //@ts-ignore
            row.map((o, i) => {

                if(!o) return;
                if(!o.data) o.data = {};

                let el: any = document.querySelector(`.v-datatable tbody td:nth-child(${i + 1})`) || {};
                //@ts-ignore
                if (!o.data.style) o.data.style = {};
                //@ts-ignore
                o.data.style.width = el.offsetWidth + 'px';
            });

            //@ts-ignore
            children = [this.genTR(row), this.genTProgress()]
        }
        window.addEventListener('resize', ()=>{this.rerender++}, false);
        return vtag('thead', [children])
    }

    genTFoot () {

        if (!this.footer)
            return;

        const vtag = this.$createElement;


        //@ts-ignore
        const row  = this.order(this.footer).map((v: any)=>{
            return vtag('td', [v])
        });

        //@ts-ignore
        if( this.selectable && !this.hasSelectAll && !this.footer.$prepend)
            row.unshift(vtag('td',{ style: { textAlign: 'left', width:'26px' } },[vtag('v-icon',['more_vert'])]));
        //@ts-ignore
        if (this.footer.$prepend) row.unshift(vtag('td',[this.footer.$prepend]));

        //@ts-ignore
        if( this.actions && this.actions.length && !this.footer.$append)
            row.push(vtag('td',{ style: { textAlign: 'right' } },[vtag('v-icon',['drag_handle'])]));

        //@ts-ignore
        if (this.footer.$append) row.unshift(vtag('td',[this.footer.$append]));

        //@ts-ignore
        row.map((o:any, i:any) => {
            if(!o) return;
            if(!o.data) o.data = {};

            let el: any = document.querySelector(`.v-datatable tbody td:nth-child(${i + 1})`) || {};

            //@ts-ignore
            if (!o.data.style) o.data.style = {};
            //@ts-ignore
            o.data.style.width = el.offsetWidth + 'px';
        });

        //@ts-ignore
        const children = this.genTR(row)

        window.addEventListener('resize', ()=>{this.rerender++}, false);
        return vtag('tfoot', [children])
    }




}
